import { render, staticRenderFns } from "./applyAttachment.vue?vue&type=template&id=3df1aa8c&scoped=true"
import script from "./applyAttachment.vue?vue&type=script&lang=js"
export * from "./applyAttachment.vue?vue&type=script&lang=js"
import style0 from "./applyAttachment.vue?vue&type=style&index=0&id=3df1aa8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df1aa8c",
  null
  
)

export default component.exports